<template>
  <div>
    <el-tag
      class="mr-10 m-b-10 pointer"
      size="medium"
      :key="temp.id"
      :effect="temp.id == value ? 'light' : 'plain'"
      :type="temp.id == value ? 'primary' : 'info'"
      @click="handleSelect(temp)"
      v-for="temp in lists"
      >{{ temp.name }}</el-tag
    >
  </div>
</template>

<script>
import { CommodityCategoryMap } from '@/config/global'

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: CommodityCategoryMap,
    }
  },
  created() {
    let category = this.value
      ? CommodityCategoryMap.filter((item) => item.id == this.value)[0]
      : CommodityCategoryMap[0]
    this.handleSelect(category)
  },
  methods: {
    handleSelect(e) {
      this.$emit('change', e)
    },
  },
}
</script>